// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'fundraising/SET_FILTER_OPTIONS' as const
export const SET_FUNDRAISING = 'fundraising/SET_FUNDRAISING' as const
export const SET_ACTIVE_FILTERS = 'fundraising/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'fundraising/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'fundraising/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'fundraising/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_PROSPECT_RECORD = 'fundraising/UPDATE_PROSPECT_RECORD' as const
export const ADD_PROSPECT = 'fundraising/ADD_PROSPECT' as const
export const APPEND_FUNDRAISING = 'fundraising/APPEND_FUNDRAISING' as const
export const SET_PIPELINE_SELECTED_FUND = 'fundraising/SET_PIPELINE_SELECTED_FUND' as const
export const REMOVE_PROSPECT_FROM_LIST = 'fundraising/REMOVE_PROSPECT_FROM_LIST' as const
